import { useAllSupportCategories } from '@/helpers/SupportHelper';
import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';

// 전체 카테고리 가져오는 훅
export const useAllSupportAnniType = (): GatsbyTypes.SupportAnniType[] => {
  const {
    allSupportAnniType: { nodes: supportAnniType },
  } = useStaticQuery<{
    allSupportAnniType: { nodes: GatsbyTypes.SupportAnniType[] };
  }>(graphql`
    query {
      allSupportAnniType(sort: { fields: code }) {
        nodes {
          code
          codeName
        }
      }
    }
  `);
  return supportAnniType;
};

/**
 * 상수로 관리되는 기념기부 코드정보
 */
export const SUPPORT_CD_ANNI_EXCLUDE: any = [`D224`, 'D302'];
export const SUPPORT_ANNI_TYPE = `AT00`;

// 기념기부에서 사용할 카테고리 가져오는 훅
export const useSupportCategoriesForAnniPrjt = (): GatsbyTypes.SupportCategory[] => {
  const supportCategories = useAllSupportCategories();
  const currentCategories = useMemo(() => {
    // 일시 후원 대상 중 제외 사업 필터링
    const categoriesWithoutIg = supportCategories.filter(
      (item) =>
        item.categoryCode === 'FM02' &&
        SUPPORT_CD_ANNI_EXCLUDE.indexOf(item.code) === -1,
    );
    return categoriesWithoutIg;
  }, [supportCategories]);

  return currentCategories;
};
